(function () {
  /* =====================  CONFIG  ===================== */
  const IS_DELIVERY_PAGE = /\/pages\/delivery-info(?:\/|$)/.test(location.pathname);
  const IS_CART_PAGE     = /\/cart(?:\/|$)/.test(location.pathname);
  const DEFAULT_ZONES_URL = 'https://cdn.shopify.com/s/files/1/0750/9282/0220/files/delivery_zones.json?v=1777378144';
  // ⬇ Update this URL after uploading delivery_dates.json to Shopify Files
  const DELIVERY_DATES_URL = 'https://cdn.shopify.com/s/files/1/0750/9282/0220/files/delivery_dates.json?v=1776401799';
  /* ==================================================== */

  // ---------- Helpers ----------
  const norm = s => (s || '').toString().trim().toLowerCase();
  const esc  = s => { const d = document.createElement('div'); d.innerText = s; return d.innerHTML; };
  const debounce = (fn, d = 120) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), d); }; };

  // Reveal helpers for the CART PAGE (not drawer)
function revealCartPageFlowIfPresent() {
  if (!IS_CART_PAGE) return;

  // Try a broad set of likely wrapper IDs/selectors (page variants + future-proof patterns)
  const CANDIDATES = [
    // date
    '#delivery-date-wrap', '#delivery-date-wrap-page', '[id^="delivery-date-wrap"]',
    // prefs
    '#preferences-wrap', '#preferences-wrap-page', '[id^="preferences-wrap"]',
    // authority
    '#authority-wrap', '[id^="authority-wrap"]',
    // leave location
    '#leave-location-wrap', '[id^="leave-location-wrap"]',
    // extras
    '#help-unload-wrap', '[id^="help-unload-wrap"]',
    '#access-issues-wrap', '[id^="access-issues-wrap"]'
  ];

  let revealedSomething = false;

  // Unhide any matching elements that are currently hidden inline
  CANDIDATES.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      const cs = window.getComputedStyle(el);
      if (el.style.display === 'none' || cs.display === 'none') {
        el.style.display = '';
        revealedSomething = true;
      }
    });
  });

  // As a fallback (in case the page has no extra steps), enable the Checkout button
  // This only runs on the cart PAGE (never the drawer).
  const checkoutBtns = document.querySelectorAll(
    'form[action="/cart"] [name="checkout"], [name="checkout"].cart__checkout, button[name="checkout"]'
  );
  checkoutBtns.forEach(btn => { btn.disabled = false; });

  // Fire a custom event in case any other script wants to react to a positive result
  try { document.dispatchEvent(new CustomEvent('pc:area-ok')); } catch(_) {}

  return revealedSomething;
}


  // ---------- Zones loader (shared) ----------
  let zonesData = null, suburbsRaw = [], suburbsNorm = [], loadP = null;

  function currentZonesUrl() {
    return (
      document.getElementById('delivery-checker-root')?.dataset?.zonesUrl ||
      document.getElementById('delivery-checker-root-cart')?.dataset?.zonesUrl ||
      DEFAULT_ZONES_URL
    );
  }

  function loadZones () {
    if (zonesData) return Promise.resolve(zonesData);
    if (!loadP) {
      loadP = fetch(currentZonesUrl(), { cache: 'no-store' })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => {
          zonesData = data || {};
          const seen = new Set();
          suburbsRaw = [];
          suburbsNorm = [];
          Object.values(zonesData).forEach(a => (a.suburbs || []).forEach(s => {
            const n = norm(s);
            if (!seen.has(n)) { seen.add(n); suburbsRaw.push(s); suburbsNorm.push(n); }
          }));
          return zonesData;
        })
        .catch(e => { console.error('[delivery-checker] zones load failed', e); });
    }
    return loadP;
  }

  // ---------- Delivery dates loader ----------
  let deliveryDates = null, deliveryDatesP = null;

  function loadDeliveryDates() {
    if (deliveryDates) return Promise.resolve(deliveryDates);
    if (!deliveryDatesP) {
      deliveryDatesP = fetch(DELIVERY_DATES_URL, { cache: 'no-store' })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => { deliveryDates = data || {}; return deliveryDates; })
        .catch(e => { console.warn('[delivery-checker] delivery dates load failed', e); return {}; });
    }
    return deliveryDatesP;
  }

  // Get allowed dates for a suburb based on its zone
  function getAllowedDatesForSuburb(suburb) {
    if (!zonesData || !deliveryDates) return null;
    const q = norm(suburb);
    for (const [zoneName, zoneInfo] of Object.entries(zonesData)) {
      const hit = (zoneInfo.suburbs || []).some(s => norm(s) === q);
      if (hit && deliveryDates[zoneName]) {
        return deliveryDates[zoneName];
      }
    }
    return null;
  }

  // Expose so cart-drawer can call it
  window.__apcGetAllowedDates = function(suburb) {
    return getAllowedDatesForSuburb(suburb);
  };
  window.__apcLoadDeliveryDates = loadDeliveryDates;

  // ---------- Search ----------
  function search (data, qSuburb) {
    const q = norm(qSuburb);
    if (!q) return [];
    if (/\d/.test(q)) return [{ area: null, summary: 'Please enter a suburb (not a postcode).' }];

    const perArea = {};
    Object.keys(data || {}).forEach(area => {
      const z = (data[area] || {});
      const hit = (z.suburbs || []).some(s => norm(s) === q);
      if (hit) {
        (perArea[area] = perArea[area] || []).push({
          frequency: (z.delivery_frequency || '').trim(),
          days:       (z.delivery_days      || '').trim()
        });
      }
    });

    const results = [];
    Object.keys(perArea).forEach(area => {
      const groups = {};
      perArea[area].forEach(e => {
        const f = e.frequency, d = e.days;
        if (!groups[f]) groups[f] = new Set();
        d.split(/[,&+/]+/).map(s => s.trim()).filter(Boolean).forEach(day => groups[f].add(day));
      });
      const parts = Object.keys(groups).filter(Boolean).map(freq => {
        const days = Array.from(groups[freq]);
        const ds = days.length ? ` (${days.join(' & ')})` : '';
        return `${freq}${ds}`;
      });
      results.push({ area, summary: parts.join(' and ') });
    });
    return results;
  }

  // ---------- Instance factory ----------
  function initInstance (cfg) {
    // cfg: { root, input, button, out, suggestBox, hintEl }
    if (!cfg.root || cfg.root._bound) return;
    cfg.root._bound = true;
    cfg.root.hidden = false;

    let hi = -1;

    const toggleHint = () => {
      if (!cfg.hintEl) return;
      const hasOut   = !!(cfg.out && cfg.out.textContent.trim());
      const hasValue = !!(cfg.input && cfg.input.value.trim());
      cfg.hintEl.style.display = (hasOut || hasValue) ? 'none' : '';
    };
    const show = html => { if (cfg.out) cfg.out.innerHTML = html || ''; toggleHint(); };

    function closeBox () {
      if (!cfg.suggestBox) return;
      cfg.suggestBox.classList.remove('visible');
      cfg.suggestBox.innerHTML = '';
      hi = -1;
      cfg.input?.setAttribute('aria-expanded', 'false');
    }
    function openBox (list) {
      if (!cfg.suggestBox) return;
      cfg.suggestBox.innerHTML = list.map((n, i) =>
        `<div class="pc-suggest-item" role="option" data-i="${i}" aria-selected="false">${esc(n)}</div>`).join('');
      cfg.suggestBox.classList.add('visible');
      cfg.input?.setAttribute('aria-expanded', 'true');
    }

    const renderSuggest = debounce(function () {
      const q = norm(cfg.input.value);
      if (q.length < 2 || /\d/.test(q)) { closeBox(); return; }
      if (!zonesData || !suburbsNorm.length) { loadZones(); return; }

      const starts = [], contains = [];
      for (let i = 0; i < suburbsNorm.length; i++) {
        const n = suburbsNorm[i];
        if (n.startsWith(q)) { if (starts.length   < 8) starts.push(suburbsRaw[i]); }
        else if (n.includes(q)) { if (contains.length < 8) contains.push(suburbsRaw[i]); }
        if (starts.length >= 8 && contains.length >= 8) break;
      }
      const list = starts.concat(contains).slice(0, 8);
      list.length ? openBox(list) : closeBox();
    }, 100);

    function highlight (i) {
      if (!cfg.suggestBox) return;
      const items = cfg.suggestBox.querySelectorAll('.pc-suggest-item');
      items.forEach(el => el.setAttribute('aria-selected', 'false'));
      if (i >= 0 && i < items.length) {
        items[i].setAttribute('aria-selected', 'true');
        hi = i;
        const el = items[i], top = el.offsetTop, bot = top + el.offsetHeight;
        if (cfg.suggestBox.scrollTop > top) cfg.suggestBox.scrollTop = top;
        if (cfg.suggestBox.scrollTop + cfg.suggestBox.clientHeight < bot)
          cfg.suggestBox.scrollTop = bot - cfg.suggestBox.clientHeight;
      } else {
        hi = -1;
      }
    }
    function pick (i) {
      const el = cfg.suggestBox?.querySelectorAll('.pc-suggest-item')[i];
      if (!el || !cfg.input) return;
      cfg.input.value = el.textContent;
      closeBox();
      cfg.input.focus();
    }
    function renderFromData (data, q) {
      const hits = search(data, q);

      if (!hits.length) {
        show(
          `Sorry, we don't deliver to <strong>${esc(q)}</strong> yet. ` +
          `<a href="/pages/contact">Contact us</a> and we'll see what's possible.`
        );
        return;
      }

      if (hits.length === 1 && hits[0].area === null) {
        show(hits[0].summary);
        return;
      }

      const summaries = Array.from(new Set(hits.map(h => h.summary).filter(Boolean)));
      const items = summaries.map(s => `<li>${esc(s)}</li>`).join('');
      show(`Yes, we deliver to <strong>${esc(q)}</strong>:<ul>${items}</ul>`);

      // <- NEW: when the cart PAGE has a positive result, reveal its flow.
      revealCartPageFlowIfPresent();

      // Load delivery dates and fire event with allowed dates for this suburb
      loadDeliveryDates().then(() => {
        const allowed = getAllowedDatesForSuburb(q);
        try {
          document.dispatchEvent(new CustomEvent('pc:suburb-confirmed', {
            detail: { suburb: q, allowedDates: allowed }
          }));
        } catch(_) {}
      });
    }
    cfg.root._renderFromData = (data, q) => renderFromData(data, q);

    function run (e) {
      if (e) { e.preventDefault?.(); e.stopPropagation?.(); }
      const q = (cfg.input?.value || '').trim();
      if (!q) { show('Please enter a suburb.'); return; }
      closeBox();
      loadZones().then(() => renderFromData(zonesData, q))
                 .catch(() => show('Error checking delivery zones.'));
    }

    cfg.button?.addEventListener('click', run, { passive: false });
    cfg.input?.addEventListener('keydown', e => {
      if (e.key === 'Enter')      { run(e); return; }
      if (e.key === 'ArrowDown')  { e.preventDefault(); highlight(hi + 1); }
      if (e.key === 'ArrowUp')    { e.preventDefault(); highlight(Math.max(hi - 1, 0)); }
      if (e.key === 'Escape')     { closeBox(); }
    }, { passive: false });
    cfg.input?.addEventListener('input', renderSuggest);
    cfg.input?.addEventListener('focus', () => { loadZones(); });
    cfg.suggestBox?.addEventListener('click', e => {
      const el = e.target.closest('.pc-suggest-item'); if (el) pick(parseInt(el.dataset.i, 10));
    });

    cfg.root.addEventListener('click', e => e.stopPropagation());
    show(cfg.out?.innerHTML || '');
  }

  // Ensure a root has handlers; used as a safety net on cart page, etc.
  function bindIfNeededWithin(root) {
    if (!root || root._bound) return;
    initInstance({
      root,
      input:      root.querySelector('#pc-input')       || root.querySelector('#pc-input-cart'),
      button:     root.querySelector('#pc-check')       || root.querySelector('#pc-check-cart'),
      out:        root.querySelector('#pc-result')      || root.querySelector('#pc-result-cart'),
      suggestBox: root.querySelector('#pc-suggest')     || root.querySelector('#pc-suggest-cart'),
      hintEl:     root.querySelector('.pc-hint') || null
    });
  }

  // If the button is clicked before init, bind and then re-fire the click once.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#pc-check, #pc-check-cart');
    if (!btn) return;
    const root = btn.closest('#delivery-checker-root, #delivery-checker-root-cart');
    if (!root) return;
    if (!root._bound) {
      e.preventDefault();
      e.stopPropagation();
      bindIfNeededWithin(root);
      setTimeout(() => { try { btn.click(); } catch(_){} }, 0);
    }
  });

  // ---------- Shared suggestion CSS ----------
  (function injectPageStyles(){
    if (document.getElementById('pc-page-suggest-css')) return;
    const style = document.createElement('style');
    style.id = 'pc-page-suggest-css';
    style.textContent = `
      #pc-suggest, #pc-suggest-cart{ max-height: 240px; overflow:auto; border:1px solid #e2e2e2; border-radius:6px; margin-top:.25rem; background:#fff; }
      #pc-suggest:not(.visible), #pc-suggest-cart:not(.visible){ display:none; }
      .pc-suggest-item{ padding:.5rem .75rem; cursor:pointer; }
      .pc-suggest-item[aria-selected="true"]{ background:#f3f3f3; }
      #pc-result, #pc-result-cart { white-space: normal; }
    `;
    document.head.appendChild(style);
  })();

  // ---------- Delivery Info page (static snippet) ----------
  function initDeliveryInfoPageIfPresent() {
    if (!IS_DELIVERY_PAGE) return;
    const root = document.getElementById('delivery-checker-root');
    if (!root) return;

    initInstance({
      root,
      input:      document.getElementById('pc-input'),
      button:     document.getElementById('pc-check'),
      out:        document.getElementById('pc-result'),
      suggestBox: document.getElementById('pc-suggest'),
      hintEl:     root.parentElement?.querySelector('small') || null
    });
  }

  // ---------- Cart PAGE widget ----------
  const PAGE_WIDGET_HTML = (zonesUrl) => `
    <div id="delivery-checker-root" class="delivery-checker" data-zones-url="${esc(zonesUrl)}">
      <label for="pc-input">ENTER YOUR SUBURB</label>
      <input id="pc-input" type="text" placeholder="e.g. Norwood" />
      <div id="pc-suggest" role="listbox" aria-label="Suburb suggestions"></div>
      <button id="pc-check" type="button">Check delivery</button>
      <div id="pc-result" aria-live="polite"></div>
    </div>
  `;

  // Page widget: Delivery Info (exclusive) + Cart page (legacy anchor)
let pageWidgetTimer = null;
function ensureCartPageWidget() {
  const IS_CART_PAGE = /\/cart(?:\/|$)/.test(location.pathname);

  // ---------------------------
  // 1) Delivery Info page ONLY
  // ---------------------------
  if (IS_DELIVERY_PAGE) {
    function mountInto(anchor) {
      if (!anchor) return false;

      // Remove any checker instances mounted outside our page anchor (e.g., footer)
      document.querySelectorAll('#delivery-checker-root').forEach(el => {
        if (!anchor.contains(el)) el.remove();
      });

      if (!anchor.querySelector('#delivery-checker-root')) {
        anchor.insertAdjacentHTML('beforeend', PAGE_WIDGET_HTML(currentZonesUrl()));
      }

      const root = anchor.querySelector('#delivery-checker-root');
      if (root && !root._bound) {
        initInstance({
          root,
          input:      root.querySelector('#pc-input'),
          button:     root.querySelector('#pc-check'),
          out:        root.querySelector('#pc-result'),
          suggestBox: root.querySelector('#pc-suggest'),
          hintEl:     anchor.querySelector('.pc-hint') || null
        });
      }

      // Kill any legacy anchors so nothing else can mount here
      document.querySelectorAll('#delivery-checker-anchor').forEach(el => el.remove());
      return true;
    }

    const okNow = mountInto(document.getElementById('delivery-checker-anchor-page'));
    if (okNow) return;

    // Try for a few seconds while sections render
    if (!pageWidgetTimer) {
      let tries = 0;
      pageWidgetTimer = setInterval(() => {
        if (mountInto(document.getElementById('delivery-checker-anchor-page')) || ++tries > 80) {
          clearInterval(pageWidgetTimer);
          pageWidgetTimer = null;
        }
      }, 100);
    }
    return;
  }

  // -----------------------------------
// 2) Cart page and other legacy spots
// -----------------------------------
if (!IS_CART_PAGE) return;

// All legacy anchors (some themes put more than one)
const anchors = Array.from(document.querySelectorAll('#delivery-checker-anchor'));
const anchor  = anchors[0] || null;
if (!anchor) return;

// Remove any extra anchors (defensive)
anchors.slice(1).forEach(a => a.remove());

// ---- LOCK: only mount once per anchor even if the section reloads
if (anchor._pcMounted) return;
anchor._pcMounted = true;

// Hard reset the anchor content so only one checker can exist inside it
anchor.innerHTML = '';

// Inject a fresh widget
anchor.insertAdjacentHTML('beforeend', PAGE_WIDGET_HTML(currentZonesUrl()));

// Bind immediately
const root = anchor.querySelector('#delivery-checker-root');
if (root && !root._bound) {
  initInstance({
    root,
    input:      root.querySelector('#pc-input'),
    button:     root.querySelector('#pc-check'),
    out:        root.querySelector('#pc-result'),
    suggestBox: root.querySelector('#pc-suggest'),
    hintEl:     anchor.querySelector('.pc-hint') || null
  });
}

// *** De-dupe: keep ONLY the instance we just mounted ***
document.querySelectorAll('#delivery-checker-root').forEach(el => {
  if (el !== root) el.remove();
});

// Warm the data for fast suggestions
try { loadZones(); } catch (_) {}

}


  // ---------- Cart DRAWER widget ----------
  const CART_HTML = (zonesUrl) => `
    <div class="delivery-checker" id="delivery-checker-root-cart" data-zones-url="${esc(zonesUrl)}">
      <label for="pc-input-cart">Enter your suburb</label>
      <input id="pc-input-cart" type="text" placeholder="e.g. Norwood" />
      <div id="pc-suggest-cart" class="pc-suggest" role="listbox"></div>
      <button id="pc-check-cart" type="button">Check delivery</button>
      <div id="pc-result-cart" aria-live="polite"></div>
    </div>
  `;

  let cartStyleInjected = false;
  let drawerRetryTimer = null;

  function ensureCartDrawerInstance() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const form = drawer.querySelector('#CartDrawerForm');
    if (!form) return;

    const field = form.querySelector('#step-area') || form;
    if (!field) return;

    let anchor = field.querySelector('#delivery-checker-anchor-cart');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.id = 'delivery-checker-anchor-cart';
      field.appendChild(anchor);
    }

    if (!anchor.querySelector('#delivery-checker-root-cart')) {
      anchor.insertAdjacentHTML('beforeend', CART_HTML(currentZonesUrl()));

      if (!cartStyleInjected) {
        const style = document.createElement('style');
        style.textContent = `
          #delivery-checker-root-cart{display:grid;gap:.5rem;margin:.5rem 0 1rem 0}
          #delivery-checker-root-cart input{padding:.5rem;border:1px solid #ccc;border-radius:.375rem}
          #delivery-checker-root-cart button{padding:.5rem .75rem;border:1px solid #333;border-radius:.375rem;background:#111;color:#fff;cursor:pointer}
          #pc-result-cart ul{margin:.25rem 0 0 1rem}
        `;
        anchor.appendChild(style);
        cartStyleInjected = true;
      }

      const root = anchor.querySelector('#delivery-checker-root-cart');
      if (root && !root._bound) {
        initInstance({
          root,
          input:      root.querySelector('#pc-input-cart'),
          button:     root.querySelector('#pc-check-cart'),
          out:        root.querySelector('#pc-result-cart'),
          suggestBox: root.querySelector('#pc-suggest-cart'),
          hintEl:     root.querySelector('.pc-hint')
        });
      }
    }
  }

  function attachCartDrawerObserver () {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer._pcMoAttached) return;
    drawer._pcMoAttached = true;

    const mo = new MutationObserver((muts) => {
      if (muts.some(m => m.type === 'childList')) ensureCartDrawerInstance();
    });
    mo.observe(drawer, { childList: true, subtree: true });

    if (drawerRetryTimer) clearInterval(drawerRetryTimer);
    let attempts = 0;
    drawerRetryTimer = setInterval(() => {
      ensureCartDrawerInstance();
      if (++attempts > 30) clearInterval(drawerRetryTimer);
    }, 100);
  }

  // ---------- Boot wiring ----------
  function boot() {
    initDeliveryInfoPageIfPresent();
    ensureCartPageWidget();
    ensureCartDrawerInstance();
    attachCartDrawerObserver();
    // Preload delivery dates in background
    try { loadDeliveryDates(); } catch(_) {}
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
